import React, { FunctionComponent, useEffect, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { Box } from "@material-ui/core";
import { useServiceStyles } from "./useServiceStyles";
import { StoreServices } from "./ServiceView/StoreServices";
import { PosServices } from "./ServiceView/PosServices";
import { api } from "../../api";
import { RouteComponentProps } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useStore } from "../../store";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};

export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

interface MatchParams {
  service_flag: string;
}

export const ServiceMaster: FunctionComponent<RouteComponentProps<
  MatchParams
>> = (props) => {
  const classes = useServiceStyles();
  const [value, setValue] = useState(0);
  const [serviceData, setServiceData] = useState({});
  const [serviceFlag, setServiceFlag] = useState(
    props.match.params.service_flag
  );
  const [serviceList, setServiceList] = useState([]);
  const [viewServicePermission, setViewServicePermission] = useState<boolean>(
    false
  );
  const [editServicePermission, setEditServicePermission] = useState<boolean>(
    false
  );
  const [addServicePermission, setAddServicePermission] = useState<boolean>(
    false
  );
  const [user] = useStore("auth", "user");

  useEffect(() => {
    const servicePermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 16
    );
    if (user.is_super_admin === true) {
      setAddServicePermission(true);
      setEditServicePermission(true);
      setViewServicePermission(true);
    } else {
      if (servicePermission) {
        if (servicePermission.is_add === true) {
          setAddServicePermission(true);
        }
        if (servicePermission.is_view === true) {
          setViewServicePermission(true);
        }
        if (servicePermission.is_edit === true) {
          setEditServicePermission(true);
        }
        if (servicePermission.is_view === false) {
          setValue(1);
          setViewServicePermission(false);
        }
        if (
          servicePermission.is_add === false &&
          servicePermission.is_edit === false &&
          servicePermission.is_view === false
        ) {
          setAddServicePermission(false);
          setEditServicePermission(false);
          setViewServicePermission(false);
        }
      }
    }
  });

  const getServiceData = async () => {
    try {
      const store_code = localStorage.getItem("authStoreCode");
      const result = await api.get(`stores/${store_code}/services`);
      setServiceData(result);
      const filterStoreServices = result.services.filter(
        (i: any) => i.is_store === "1"
      );
      setServiceList(filterStoreServices);
    } catch (error) {
      console.log(error);
    }
  };

  if (serviceFlag !== "false") {
    getServiceData();
    setServiceFlag("false");
  }

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    getServiceData();
  };

  return (
    <>
      <Helmet>
        <title>Services</title>
      </Helmet>

      <div className={classes.root}>
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="simple tabs example"
          >
            <Tab
              label="Store"
              style={{ display: viewServicePermission ? "" : "none" }}
            />
            <Tab
              label="Pos"
              style={{ display: viewServicePermission ? "" : "none" }}
            />
          </Tabs>
        </AppBar>
        {viewServicePermission ? (
          <TabPanel value={value} index={0}>
            <StoreServices
              serviceList={serviceList}
              getServiceData={getServiceData}
            />
          </TabPanel>
        ) : (
          ""
        )}
        {viewServicePermission ? (
          <TabPanel value={value} index={1}>
            <PosServices serviceData={serviceData} />
          </TabPanel>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
